import { computed, ComputedRef } from 'vue'

import { CommonEventDetailId } from '@collector/sportsapi-client-legacy'
import { useEventDetails } from '@desktop/views/Relation/composables'

export function useEventPeriod(): {
  numberOfPeriods: ComputedRef<number>
  periodLengthMinutes: ComputedRef<number>
  extraPeriodLengthMinutes: ComputedRef<number>
} {
  const { getEventDetailValue } = useEventDetails()

  const numberOfPeriods = computed(() =>
    Number(getEventDetailValue(CommonEventDetailId.NumberOfPeriods)),
  )

  const periodLengthMinutes = computed(() =>
    Number(getEventDetailValue(CommonEventDetailId.PeriodLength)),
  )

  const extraPeriodLengthMinutes = computed(() =>
    Number(getEventDetailValue(CommonEventDetailId.ExtraPeriodLength)),
  )

  return {
    numberOfPeriods,
    periodLengthMinutes,
    extraPeriodLengthMinutes,
  }
}
